import React from "react";
import { formatDate } from "../../helpers/datetime";
import { hiddenBy, hiddenText } from "../lib/format";
import { Button } from "../ui";

// E12: hidden records leave the People / Company lists only. Elsewhere
// they are shown with this small muted label.
export function HiddenLabel({ at, source }) {
    if (!at) return null;
    const by = hiddenBy(source);
    return (
        <span className="hz-hidden-label" title={`Hidden from its list on ${formatDate(at)}${by ? ` by ${by}` : ""}`}>
            <i className="ri-eye-off-line"></i>hidden
        </span>
    );
}

// Banner at the top of a hidden contact's or company's page.
export function HiddenBanner({ kind, entity, onUnhide, busy }) {
    if (!entity || !entity.hidden_at) return null;
    return (
        <div className="hz-alert hz-alert-info hz-row" style={{ marginBottom: 16, gap: 8 }}>
            <i className="ri-eye-off-line"></i>
            <span className="hz-spacer">{hiddenText(kind, entity.hidden_at, entity.hidden_source, formatDate)}</span>
            <Button size="sm" variant="soft" icon="ri-eye-line" disabled={busy} onClick={onUnhide}>Unhide</Button>
        </div>
    );
}
